import React, { Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import Loader from "./Loader";
import useCloseKycState from "../hooks/useCloseKycState";

const RequestType = lazy(() => import("./RequestType"));
const CheckActiveUser = lazy(() => import("./CheckActiveUser"));
const ActiveUserInfo = lazy(() => import("./ActiveUserInfo"));
const CheckPrevRequest = lazy(() => import("./CheckPrevRequest"));
const Reason = lazy(() => import("./Reason"));
const Review = lazy(() => import("./Review"));
const AccountClosure = lazy(() => import("./AccountClosure"));
const ESignature = lazy(() => import("./ESignature"));

const CloseKycScreen = () => {
  const {
    requestType,
    setRequestType,
    isLoading,
    setIsLoading,
    pageName,
    setPageName,
    activeUserDetail,
    setActiveUserDetail,
    dematInfo,
    setDematInfo,
  } = useCloseKycState();

  const { accountClosureScreen } = useSelector((state) => state.theme);

  const getStepScreen = (step) => {
    switch (step) {
      case "CheckActiveUser":
        return (
          <CheckActiveUser
            activeUserDetail={activeUserDetail}
            setPageName={setPageName}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setActiveUserDetail={setActiveUserDetail}
          />
        );
      case "ActiveUserInfo":
        return (
          <ActiveUserInfo
            requestType={requestType}
            activeUserDetail={activeUserDetail}
            dematInfo={dematInfo}
            isLoading={isLoading}
            setPageName={setPageName}
            setIsLoading={setIsLoading}
            setDematInfo={setDematInfo}
          />
        );
      case "CheckPrevRequest":
        return (
          <CheckPrevRequest
            activeUserDetail={activeUserDetail}
            requestType={requestType}
            dematInfo={dematInfo}
            isLoading={isLoading}
            setPageName={setPageName}
            setIsLoading={setIsLoading}
            accountClosureScreen={accountClosureScreen}
          />
        );
      case "Reason":
        return (
          <Reason
            requestType={requestType}
            setPageName={setPageName}
            accountClosureScreen={accountClosureScreen}
          />
        );
      case "AccountClosure":
        return (
          <AccountClosure
            requestType={requestType}
            activeUserDetail={activeUserDetail}
            isLoading={isLoading}
            setPageName={setPageName}
            setIsLoading={setIsLoading}
          />
        );
      case "Review":
        return (
          <Review
            requestType={requestType}
            setPageName={setPageName}
            accountClosureScreen={accountClosureScreen}
          />
        );
      case "ESignature":
        return (
          <ESignature
            requestType={requestType}
            setPageName={setPageName}
          />
        );
      default:
        return (
          <RequestType
            setRequestType={setRequestType}
            setPageName={setPageName}
          />
        );
    }
  };

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <Suspense fallback={<Loader />}>{getStepScreen(pageName)}</Suspense>
    </React.Fragment>
  );
};

export default CloseKycScreen;
